import React from 'react';
import styled from 'styled-components';

export default styled(({ value, ...rest }) => <div {...rest} />)`
  position: relative;
  right: 0;
  top: 1px;
  padding: 0 0.75rem;
  font-size: 0.8rem;
  display: ${({ value }) => (!value ? 'block' : 'none')};
  line-height: 2rem;
  color: #888;
  cursor: text;
  float:right;
  margin-top: -5px;
  margin-bottom: 5px;
`;
